export function getCssVariable(varName: string): string {
  const prefixedVarName = varName.startsWith('--') ? varName : `--${varName}`
  const rootStyles = getComputedStyle(document.documentElement)
  return rootStyles.getPropertyValue(prefixedVarName).trim()
}
